/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { IdentifiedCompanyResponse } from './';
import {
    IdentifiedCompanyResponseFromJSON,
    IdentifiedCompanyResponseFromJSONTyped,
    IdentifiedCompanyResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProvidedClientResponse
 */
export interface ProvidedClientResponse {
    /**
     * 
     * @type {string}
     * @memberof ProvidedClientResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ProvidedClientResponse
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof ProvidedClientResponse
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof ProvidedClientResponse
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof ProvidedClientResponse
     */
    phoneNumber?: string;
    /**
     * 
     * @type {IdentifiedCompanyResponse}
     * @memberof ProvidedClientResponse
     */
    identifiedCompany?: IdentifiedCompanyResponse;
}

/**
 * Check if a given object implements the ProvidedClientResponse interface.
 */
export function instanceOfProvidedClientResponse(value: object): value is ProvidedClientResponse {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstname' in value) || value['firstname'] === undefined) return false;
    if (!('lastname' in value) || value['lastname'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    return true;
}

export function ProvidedClientResponseFromJSON(json: any): ProvidedClientResponse {
    return ProvidedClientResponseFromJSONTyped(json, false);
}

export function ProvidedClientResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProvidedClientResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'companyName': json['companyName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'identifiedCompany': json['identifiedCompany'] == null ? undefined : IdentifiedCompanyResponseFromJSON(json['identifiedCompany']),
    };
}

export function ProvidedClientResponseToJSON(value?: ProvidedClientResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'companyName': value['companyName'],
        'phoneNumber': value['phoneNumber'],
        'identifiedCompany': IdentifiedCompanyResponseToJSON(value['identifiedCompany']),
    };
}

